export enum GlobalEventName {
	CopySlip = 'copy-slip',
}
export const DATA_EVENT_SELECTOR = '[data-event]';
export const DATA_EVENT = 'data-event';
export const DATA_VALUE = 'data-value';
